import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  collateral_cash: {
    name: 'Collateral Cash amount posted to all counterparties',
    order: 157
  },
  collateral_securities: {
    name: 'Collateral Securities amount posted to all counterparties',
    order: 158
  },
  other_collateral_posted: {
    name: 'Other Collateral amount posted to all counterparties',
    order: 159
  }
};
export function ValueOfCollateral({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.ALL_COUNTERPARTY_COLLATERAL,
    onChangeFund,
    schema: schema.ALL_COUNTERPARTY_COLLATERAL,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.ALL_COUNTERPARTY_COLLATERAL?.field_names || [],
    tableName: 'ALL_COUNTERPARTY_COLLATERAL',
    columnLables,
    isMultiFunds,
    funds
  });

  return (
    <Table
      id="reporttables-value-of-collateral-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
